import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["body", "form"]

  connect() {
    this.bodyTarget.addEventListener("keydown", (e) => {
      if (e.which === 13 && !e.shiftKey) {
        this.formTarget.submit()
        e.preventDefault()
      }
    })
  }
}
